/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Account } from '../models/Account';
import type { ChangePasswordRequest } from '../models/ChangePasswordRequest';
import type { CreateResetPasswordTokenRequest } from '../models/CreateResetPasswordTokenRequest';
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { HashPasswordRequest } from '../models/HashPasswordRequest';
import type { LockoutRequest } from '../models/LockoutRequest';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { SignInRequest } from '../models/SignInRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WhoopAuthResourceV2Service {

    /**
     * Change password using the current password and a new password
     * @returns any Successfully changed password
     * @throws ApiError
     */
    public static changePassword({
        requestBody,
    }: {
        requestBody: ChangePasswordRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/whoop/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed header`,
                401: `Stale access_token`,
                403: `Bad current password`,
                422: `New password too short or matches current password`,
                500: `Server error`,
            },
        });
    }

    /**
     * Internal endpoint. Create a reset_password_token on behalf of an account.
     * @returns any Reset token generated successfully
     * @throws ApiError
     */
    public static createResetPasswordToken({
        requestBody,
    }: {
        requestBody: CreateResetPasswordTokenRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/reset-password/token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed request or header`,
                500: `Server error`,
            },
        });
    }

    /**
     * A user can sign-out of all devices here.
     * @returns any Success
     * @throws ApiError
     */
    public static deleteAllTokensForSelf({
        apiToken,
    }: {
        apiToken?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/whoop/tokens',
            headers: {
                'API-TOKEN': apiToken,
            },
            errors: {
                400: `Malformed request or header`,
                403: `A backend service tried to call this endpoint, use /nuke instead`,
                500: `Server error`,
            },
        });
    }

    /**
     * @returns any default response
     * @throws ApiError
     */
    public static disableAccount(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/whoop/account',
        });
    }

    /**
     * Internal Only - Generate V2 Password Hash
     * Used by api-server to populate v2 hash. This will be deleted after Secure the Front Door part 2 is rolled out.
     * @returns any Successfully invalidated the refresh token
     * @throws ApiError
     */
    public static hashPassword({
        requestBody,
    }: {
        requestBody: HashPasswordRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/password/hash',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed header`,
                500: `Server error`,
            },
        });
    }

    /**
     * @returns Account default response
     * @throws ApiError
     */
    public static integrationTestSignUp({
        requestBody,
    }: {
        requestBody: SignInRequest,
    }): CancelablePromise<Account> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/sign-up',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Internal Only - Revoke tokens
     * You must always provide the userId query param. The token and type query params are optional. If you submit only the userId, all tokens will be revoked. If you submit the userId and tokenType, all tokens of that type for the user will be revoked. If you submit the userId, token, and tokenType that specific token will be revoked. You may not submit a token without a tokenType.
     * @returns any Successfully revoked token(s)
     * @throws ApiError
     */
    public static nukeTokens({
        type,
        token,
    }: {
        type?: 'refresh' | 'access' | 'reset_password',
        token?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/whoop/nuke',
            query: {
                'type': type,
                'token': token,
            },
            errors: {
                400: `Token string provided without token type`,
                401: `Bad auth header, this endpoint does not accept bearer tokens`,
                403: `Token not owned by provided userId`,
                404: `Token+TokenType does not exist`,
                500: `Server error`,
            },
        });
    }

    /**
     * Refresh WHOOP token set
     * @returns any Successfully refreshed
     * @throws ApiError
     */
    public static refresh({
        authorization,
    }: {
        authorization: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/refresh',
            headers: {
                'Authorization': authorization,
            },
            errors: {
                400: `Malformed header`,
                401: `Consumed or expired refresh token supplied`,
                500: `Server error`,
            },
        });
    }

    /**
     * Consume a reset-password token to update an account's password
     * @returns any Password updated successfully
     * @throws ApiError
     */
    public static resetPassword1({
        authorization,
        requestBody,
    }: {
        authorization: string,
        requestBody: ResetPasswordRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/whoop/reset-password',
            headers: {
                'Authorization': authorization,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed request or header`,
                500: `Server error`,
            },
        });
    }

    /**
     * Request a reset-password email to be sent to the supplied email
     * @returns any If the account does exist, an email was successfully sent
     * @throws ApiError
     */
    public static sendResetPasswordEmail({
        v2 = false,
        requestBody,
    }: {
        /**
         * Should the new version of the forgot password be sent (via Segment/Iterable)
         */
        v2?: boolean,
        requestBody?: ForgotPasswordRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/forgot-password',
            query: {
                'v2': v2,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed request`,
                500: `Server error`,
            },
        });
    }

    /**
     * Sign-in to the WHOOP App
     * @returns any Successfully signed in
     * @throws ApiError
     */
    public static signIn({
        requestBody,
    }: {
        requestBody: SignInRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/sign-in',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Malformed request`,
                401: `Username and Password combination is incorrect`,
                500: `Server error`,
            },
        });
    }

    /**
     * Sign-out of WHOOP by invalidating the refresh token
     * Clients should also delete all locally stored credentials
     * @returns any Successfully invalidated the refresh token
     * @throws ApiError
     */
    public static signOut({
        authorization,
    }: {
        authorization: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/whoop/sign-out',
            headers: {
                'Authorization': authorization,
            },
            errors: {
                400: `Malformed header`,
                401: `Stale refresh_token`,
                500: `Server error`,
            },
        });
    }

    /**
     * Lockout an account
     * @returns string Successfully created lockout
     * @throws ApiError
     */
    public static lockout({
        requestBody,
    }: {
        requestBody: LockoutRequest,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/whoop/lockout',
            body: requestBody,
            mediaType: 'application/json',
            responseHeader: 'Location',
            errors: {
                400: `Malformed request`,
                401: `Username and Password combination is incorrect`,
                500: `Server error`,
            },
        });
    }

}
